import React from 'react';
import Framework from "@beardeddevops/react.framework";
import {Objects} from "components";

const breadcrumbsStatic = [
	{
		name: 'Dashboard',
		url: '/',
		icon: 'dashboard',
	},
	{
		name: 'ERP',
		url: '/erp',
		icon: 'industry',
	},
	{
		name: 'Job Creation',
		url: '/erp/jobs',
		icon: 'sitemap',
	},
];

export default class MrpJobs extends Framework.Components.View {
	render() {
		return (
			<div className="container-fluid">
				<Framework.Components.PageBar
					breadcrumbs={breadcrumbsStatic}
					history={this.props.history}
				/>
				<Objects.MrpJob
					parent={this.props.match.params.id}
					id={this.props.match.params.id}
					history={this.props.history}
					locations={this.props.locations}
					states={this.props.states}
					reloadShell={this.props.reloadShell}
					reloadPage={this.refreshPage}
					reloadSelf={this.state.refresh}
					updateName={this.updateName}
					baseUrl={this.props.baseUrl}
				/>

			</div>
		);
	}
}
